(function () {
  'use strict';

  var DD_COLLECTION_COPY={"tr":{"products":"Ürünler yükleniyor…","plain":"Yükleniyor..."},"en":{"products":"Loading products…","plain":"Loading..."},"es":{"products":"Cargando productos…","plain":"Cargando..."},"ru":{"products":"Товары загружаются…","plain":"Загрузка..."},"ar":{"products":"جارٍ تحميل المنتجات…","plain":"جارٍ التحميل..."},"de":{"products":"Produkte werden geladen…","plain":"Wird geladen..."},"fr":{"products":"Chargement des produits…","plain":"Chargement..."}};
  function ddCollectionCopy(){return DD_COLLECTION_COPY[String(document.documentElement.lang||"tr").toLowerCase().split("-")[0]]||DD_COLLECTION_COPY.tr;}

  function qsa(selector, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(selector));
  }

  function isVisible(element) {
    return !!(element && (element.offsetWidth || element.offsetHeight || element.getClientRects().length));
  }

  function formatMoney(cents) {
    var number = Number(cents);
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'TRY';
    var locale = document.documentElement.lang || 'tr-TR';

    if (!Number.isFinite(number)) return '';

    try {
      if (currency === 'TRY') {
        return new Intl.NumberFormat('tr-TR', {
          minimumFractionDigits: 0,
          maximumFractionDigits: 2,
        }).format(number / 100) + ' TL';
      }

      return new Intl.NumberFormat(locale, { style: 'currency', currency: currency }).format(number / 100);
    } catch (error) {
      var amount = number / 100;
      if (currency === 'TRY') return (Number.isInteger(amount) ? Math.round(amount).toLocaleString('tr-TR') : amount.toFixed(2).replace('.', ',')) + ' TL';
      return amount.toFixed(2) + ' ' + currency;
    }
  }

  function initMoney(root) {
    qsa('[data-dd-money-cents]', root).forEach(function (node) {
      var text = formatMoney(node.getAttribute('data-dd-money-cents'));
      node.textContent = text;
      node.classList.add('notranslate');
      node.setAttribute('translate', 'no');
      node.setAttribute('data-faire-original-try-price', text);
    });
  }

  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem('dd_wishlist_product_ids') || '[]').map(String);
    } catch (error) {
      return [];
    }
  }

  function cartHeader() {
    return document.querySelector('.faire-dawn-header-section');
  }

  function ensureCartOpen() {
    var header = cartHeader();
    if (!header) return;

    var dropdown = header.querySelector('[data-faire-dropdown="cart"]');
    if (dropdown && dropdown.classList.contains('is-open')) return;

    var controls = qsa('[data-faire-toggle-dropdown="cart"],[data-faire-dock-cart]', header);
    var control = controls[0];
    var index;

    for (index = 0; index < controls.length; index += 1) {
      if (isVisible(controls[index])) {
        control = controls[index];
        break;
      }
    }

    if (control) control.click();
    else if (dropdown) dropdown.classList.add('is-open');
  }

  function updateCount(cart) {
    if (!cart || typeof cart.item_count === 'undefined') return;

    qsa('[data-faire-cart-count],[data-cart-count],.faire-site-header__cart-count,.faire-dock__cart-count').forEach(
      function (node) {
        node.textContent = cart.item_count;
        node.hidden = cart.item_count < 1;
      }
    );
  }

  function emitCart(cart) {
    var detail = { cart: cart, source: 'ddnn' };

    ['cart:refresh', 'cart:updated', 'cart:update', 'faire:cart:refresh', 'faire:cart:updated'].forEach(
      function (name) {
        document.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: detail }));
        window.dispatchEvent(new CustomEvent(name, { detail: detail }));
      }
    );
  }

  function fastAdd(form, button) {
    var id = Number((form.querySelector('[name="id"]') || {}).value);
    var quantity = Number((form.querySelector('[name="quantity"]') || {}).value || 1);
    var addUrl;
    var cartUrl;

    if (!id) return Promise.reject(new Error('variant'));

    ensureCartOpen();
    button.disabled = true;
    button.classList.add('is-loading');
    button.setAttribute('aria-busy', 'true');

    addUrl = (window.routes && window.routes.cart_add_url) || form.action || '/cart/add';
    if (!/\.js(?:\?|$)/.test(addUrl)) addUrl = addUrl.replace(/\/$/, '') + '.js';

    cartUrl = ((window.routes && window.routes.cart_url) || '/cart').replace(/\/$/, '') + '.js';

    return fetch(addUrl, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify({ items: [{ id: id, quantity: quantity }] }),
    })
      .then(function (response) {
        if (!response.ok) throw new Error('add');
        return response.json();
      })
      .then(function () {
        return fetch(cartUrl, {
          credentials: 'same-origin',
          cache: 'no-store',
          headers: { Accept: 'application/json' },
        });
      })
      .then(function (response) {
        if (!response.ok) throw new Error('cart');
        return response.json();
      })
      .then(function (cart) {
        updateCount(cart);
        emitCart(cart);
        ensureCartOpen();
        button.classList.remove('is-loading');
        button.classList.add('is-added');
        button.setAttribute('aria-label', 'Sepete eklendi');
      })
      .finally(function () {
        setTimeout(function () {
          button.disabled = false;
          button.classList.remove('is-loading', 'is-added');
          button.removeAttribute('aria-busy');
          button.setAttribute('aria-label', 'Sepete ekle');
        }, 650);
      });
  }

  function bindCards(root) {
    initMoney(root);
    var ids = getWishlist();

    qsa('[data-ddnn-wishlist]', root).forEach(function (button) {
      var card = button.closest('[data-product-id]');
      var id = card ? String(card.dataset.productId) : '';

      button.classList.toggle('is-active', ids.indexOf(id) > -1);
      button.setAttribute('aria-pressed', ids.indexOf(id) > -1 ? 'true' : 'false');

      if (button.dataset.bound === '1') return;
      button.dataset.bound = '1';

      button.addEventListener('click', function (event) {
        event.preventDefault();

        var current = getWishlist();
        var position = current.indexOf(id);

        if (position > -1) current.splice(position, 1);
        else current.push(id);

        localStorage.setItem('dd_wishlist_product_ids', JSON.stringify(current));
        button.classList.toggle('is-active', current.indexOf(id) > -1);
        button.setAttribute('aria-pressed', current.indexOf(id) > -1 ? 'true' : 'false');
      });
    });

    qsa('[data-ddnn-quick-add]', root).forEach(function (form) {
      if (form.dataset.bound === '1') return;
      form.dataset.bound = '1';

      form.addEventListener('submit', function (event) {
        var button = form.querySelector('button');
        if (!window.fetch || !button || button.disabled) return;

        event.preventDefault();
        fastAdd(form, button).catch(function () {
          form.submit();
        });
      });
    });
  }

  function normalizePriceValue(value) {
    if (value === null || value === undefined) return '';

    var normalized = String(value).trim().replace(/\s/g, '');
    if (!normalized) return '';

    if (normalized.indexOf(',') > -1 && normalized.indexOf('.') > -1) {
      if (normalized.lastIndexOf(',') > normalized.lastIndexOf('.')) {
        normalized = normalized.replace(/\./g, '').replace(',', '.');
      } else {
        normalized = normalized.replace(/,/g, '');
      }
    } else if (normalized.indexOf(',') > -1) {
      normalized = normalized.replace(',', '.');
    }

    return normalized;
  }

  function buildFilterUrl(form) {
    var action = form.getAttribute('action') || window.location.pathname;
    var url = new URL(action, window.location.origin);
    var formData = new FormData(form);
    var params = new URLSearchParams();

    formData.forEach(function (rawValue, key) {
      var value = rawValue;

      if (/filter\.v\.price\.(gte|lte)/.test(key)) {
        value = normalizePriceValue(rawValue);
      }

      if (value === '') return;
      params.append(key, value);
    });

    params.delete('page');
    // Preserve theme preview context: otherwise async filters may accidentally render
    // the live theme while the merchant is testing the unpublished draft.
    var source = new URL(window.location.href);
    ['preview_theme_id', '_fd', 'pb'].forEach(function(key) {
      if (source.searchParams.has(key) && !params.has(key)) params.set(key, source.searchParams.get(key));
    });
    url.search = params.toString();
    return url.toString();
  }

  var filterRequestController = null;
  var filterRequestSequence = 0;
  function renderFilteredUrl(targetUrl, pushState, root) {
    if (!root || !root.dataset.ddnnSectionId) {
      window.location.assign(targetUrl);
      return;
    }
    var nextUrl = new URL(targetUrl, window.location.origin);
    var requestUrl = new URL(nextUrl.toString());
    requestUrl.searchParams.set('section_id', root.dataset.ddnnSectionId);
    var sectionId = root.dataset.ddnnSectionId;
    var wasDesktopOpen = !!(root.querySelector('[data-ddnn-desktop-panel]') && !root.querySelector('[data-ddnn-desktop-panel]').hidden);
    var seq = ++filterRequestSequence;
    if (filterRequestController) filterRequestController.abort();
    filterRequestController = typeof AbortController !== 'undefined' ? new AbortController() : null;
    root.classList.add('is-filtering');
    root.setAttribute('aria-busy', 'true');
    var opts = { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'text/html' } };
    if (filterRequestController) opts.signal = filterRequestController.signal;
    fetch(requestUrl.toString(), opts)
      .then(function(response) {
        if (!response.ok) throw new Error('filter_http_' + response.status);
        return response.text();
      })
      .then(function(html) {
        if (seq !== filterRequestSequence) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var updated = doc.querySelector('[data-ddnn-collection][data-ddnn-section-id]');
        if (!updated || !updated.querySelector('[data-ddnn-grid]') || updated.dataset.ddnnSectionId !== sectionId) throw new Error('missing_rendered_section');
        var fresh = document.importNode(updated, true);
        if (pushState) window.history.pushState({ ddnnFilters: true }, '', nextUrl.pathname + nextUrl.search + nextUrl.hash);
        root.replaceWith(fresh);
        var panel = fresh.querySelector('[data-ddnn-desktop-panel]');
        var button = fresh.querySelector('[data-ddnn-open]');
        if (wasDesktopOpen && panel) {
          panel.hidden = false;
          if (button) button.setAttribute('aria-expanded', 'true');
        }
        boot(document);
        document.dispatchEvent(new Event('dd:collection:rendered'));
      })
      .catch(function(error) {
        if (error && error.name === 'AbortError') return;
        if (seq === filterRequestSequence) window.location.assign(nextUrl.toString());
      })
      .finally(function() {
        if (seq === filterRequestSequence) {
          var current = document.querySelector('[data-ddnn-collection][data-ddnn-section-id="' + sectionId + '"]');
          if (current) { current.classList.remove('is-filtering'); current.removeAttribute('aria-busy'); }
          filterRequestController = null;
        }
      });
  }
  function navigateFilter(form, root) {
    if (!form) return;
    // Use Shopify's native server-side filtering. Preserve draft theme preview context.
    // Avoid partial rendering failures that left stale products on screen.
    var target = buildFilterUrl(form);
    window.location.assign(target);
  }

  function repairDesktopFacets(root) {
    var toolbar = root.querySelector('.ddnn-toolbar');
    var toolbarInner = root.querySelector('.ddnn-toolbar__inner');
    var facets = root.querySelector('.ddnn-facets');
    if (root.dataset.ddnnFilterEnhanced === 'true') return;
    var isDesktop = window.matchMedia('(min-width: 901px)').matches;

    if (!toolbar || !facets) return;

    if (isDesktop) {
      toolbar.style.position = 'relative';
      toolbar.style.zIndex = '70';
      toolbar.style.overflow = 'visible';
      if (toolbarInner) toolbarInner.style.overflow = 'visible';
      facets.style.overflow = 'visible';
      facets.style.flexWrap = 'wrap';
    } else {
      toolbar.style.removeProperty('position');
      toolbar.style.removeProperty('z-index');
      toolbar.style.removeProperty('overflow');
      if (toolbarInner) toolbarInner.style.removeProperty('overflow');
      facets.style.removeProperty('overflow');
      facets.style.removeProperty('flex-wrap');
    }
  }

  function bindFacets(root) {
    var desktopForm = root.querySelector('form.ddnn-facets');
    var drawerForm = root.querySelector('[data-ddnn-drawer] form');

    [desktopForm, drawerForm].forEach(function (form) {
      if (!form || form.dataset.ddnnFilterBound === '1') return;
      form.dataset.ddnnFilterBound = '1';

      form.addEventListener('submit', function (event) {
        event.preventDefault();
        navigateFilter(form, root);
      });
    });

    qsa('[data-ddnn-auto]', root).forEach(function (input) {
      if (input.dataset.ddnnFilterBound === '1') return;
      input.dataset.ddnnFilterBound = '1';

      input.addEventListener('change', function () {
        navigateFilter(input.closest('form'), root);
      });
    });

    if (root.dataset.ddnnFilterEnhanced !== 'true') {
    qsa('.ddnn-facet > summary', root).forEach(function (summary) {
      if (summary.dataset.ddnnFacetBound === '1') return;
      summary.dataset.ddnnFacetBound = '1';

      summary.addEventListener('click', function () {
        var current = summary.parentElement;
        qsa('.ddnn-facets .ddnn-facet[open]', root).forEach(function (details) {
          if (details !== current) details.removeAttribute('open');
        });
      });
    });

    if (root.dataset.ddnnOutsideFacetBound !== '1') {
      root.dataset.ddnnOutsideFacetBound = '1';
      document.addEventListener('click', function (event) {
        if (!root.isConnected || event.target.closest('.ddnn-facet')) return;
        qsa('.ddnn-facets .ddnn-facet[open]', root).forEach(function (details) {
          details.removeAttribute('open');
        });
      });
    }

    }
    if (root.dataset.ddnnClearLinksBound !== '1') {
      root.dataset.ddnnClearLinksBound = '1';
      root.addEventListener('click', function(event) {
        var link = event.target.closest('[data-ddnn-clear], .ddnn-active a');
        if (!link || !root.contains(link)) return;
        var href = link.getAttribute('href');
        if (!href || href.charAt(0) === '#') return;
        var target = new URL(href, window.location.origin);
        if (target.origin !== window.location.origin) return;
        event.preventDefault();
        var preview = new URL(window.location.href);
        ['preview_theme_id','_fd','pb'].forEach(function(key) {
          if (preview.searchParams.has(key)) target.searchParams.set(key, preview.searchParams.get(key));
        });
        window.location.assign(target.toString());
      });
    }

    repairDesktopFacets(root);

    if (root.dataset.ddnnFacetResizeBound !== '1') {
      root.dataset.ddnnFacetResizeBound = '1';
      window.addEventListener('resize', function () {
        repairDesktopFacets(root);
      });
    }
  }

  function init(root) {
    if (root.dataset.init === '1') return;
    // The desktop reference panel starts expanded; mobile uses its own drawer.
    var desktopRef = root.querySelector('[data-ddnn-desktop-panel]');
    var openRefButton = root.querySelector('[data-ddnn-open]');
    if (openRefButton && desktopRef) {
      openRefButton.setAttribute('aria-expanded', desktopRef.hidden ? 'false' : 'true');
    }
    root.dataset.init = '1';

    var drawer = root.querySelector('[data-ddnn-drawer]');
    var backdrop = root.querySelector('[data-ddnn-backdrop]');

    var desktopPanel = root.querySelector('[data-ddnn-desktop-panel]');
    var toggle = root.querySelector('[data-ddnn-open]');
    function open() {
      if (window.matchMedia('(min-width: 901px)').matches && desktopPanel) {
        desktopPanel.hidden = !desktopPanel.hidden;
        if (toggle) toggle.setAttribute('aria-expanded', desktopPanel.hidden ? 'false' : 'true');
        return;
      }
      if (!drawer) return;
      drawer.classList.add('is-open');
      if (backdrop) backdrop.classList.add('is-open');
      if (toggle) toggle.setAttribute('aria-expanded', 'true');
      document.documentElement.style.overflow = 'hidden';
      var closeButton = drawer.querySelector('[data-ddnn-close]');
      if (closeButton) closeButton.focus();
    }
    function close() {
      if (drawer) drawer.classList.remove('is-open');
      if (backdrop) backdrop.classList.remove('is-open');
      if (desktopPanel) desktopPanel.hidden = true;
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
      document.documentElement.style.overflow = '';
    }

    qsa('[data-ddnn-open]', root).forEach(function (button) {
      button.addEventListener('click', open);
    });

    qsa('[data-ddnn-close]', root).forEach(function (button) {
      button.addEventListener('click', close);
    });

    if (backdrop) backdrop.addEventListener('click', close);
    root.addEventListener('keydown', function(event) {
      if (event.key === 'Escape') close();
    });
    qsa('[data-ddnn-option-search]', root).forEach(function(input) {
      input.addEventListener('input', function() {
        var needle = input.value.trim().toLocaleLowerCase(document.documentElement.lang || 'tr');
        var group = input.closest('[data-ddnn-filter-group]');
        if (!group) return;
        qsa('[data-ddnn-filter-option]', group).forEach(function(row) {
          var label = row.querySelector('.ddnn-advanced-option-label');
          row.hidden = !!(needle && label && label.textContent.toLocaleLowerCase(document.documentElement.lang || 'tr').indexOf(needle) < 0);
        });
      });
    });
    qsa('[data-ddnn-price]', root).forEach(function(priceBox) {
      var minSlider = priceBox.querySelector('[data-ddnn-price-slider="min"]');
      var maxSlider = priceBox.querySelector('[data-ddnn-price-slider="max"]');
      var minNumber = priceBox.querySelector('[data-ddnn-price-number="min"]');
      var maxNumber = priceBox.querySelector('[data-ddnn-price-number="max"]');
      if (!minSlider || !maxSlider || !minNumber || !maxNumber) return;
      function adjust(changed) {
        var min = Math.max(0, Number(minSlider.value) || 0);
        var max = Math.min(Number(maxSlider.max), Number(maxSlider.value) || 0);
        if (min > max) {
          if (changed === 'min') maxSlider.value = String(min);
          else minSlider.value = String(max);
        }
        minNumber.value = Number(minSlider.value) === 0 ? '' : minSlider.value;
        maxNumber.value = Number(maxSlider.value) >= Number(maxSlider.max) ? '' : maxSlider.value;
        updateRangeTrack();
      }
      function updateRangeTrack() {
        var maximum = Math.max(1, Number(maxSlider.max) || 1);
        priceBox.style.setProperty('--ddnn-range-min', (100 * Math.max(0, Number(minSlider.value)) / maximum) + '%');
        priceBox.style.setProperty('--ddnn-range-max', (100 * Math.min(maximum, Number(maxSlider.value)) / maximum) + '%');
        var readout = priceBox.querySelector('[data-ddnn-price-readout]');
        if (readout) {
          var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'TRY';
          var formatter = new Intl.NumberFormat(document.documentElement.lang || 'tr-TR', {maximumFractionDigits:0});
          readout.textContent = formatter.format(Number(minSlider.value)) + ' – ' + formatter.format(Number(maxSlider.value)) + ' ' + (currency === 'TRY' ? 'TL' : currency);
        }
      }
      updateRangeTrack();
      minSlider.addEventListener('input', function(){adjust('min');});
      maxSlider.addEventListener('input', function(){adjust('max');});
      minNumber.addEventListener('change', function(){minSlider.value = minNumber.value || '0';adjust('min');});
      maxNumber.addEventListener('change', function(){maxSlider.value = maxNumber.value || maxSlider.max;adjust('max');});
    });
    bindFacets(root);

    qsa('[data-ddnn-sort]', root).forEach(function (select) {
      if (select.dataset.ddnnSortBound === '1') return;
      select.dataset.ddnnSortBound = '1';

      select.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', select.value);
        url.searchParams.delete('page');
        renderFilteredUrl(url.toString(), true, root);
      });
    });

    var load = root.querySelector('[data-ddnn-loadmore]');
    if (load) {
      load.addEventListener('click', function () {
        var url = load.dataset.url;
        if (!url) return;

        load.disabled = true;
        var old = load.textContent;
        load.textContent = ddCollectionCopy().plain;

        fetch(url, { credentials: 'same-origin' })
          .then(function (response) {
            return response.text();
          })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var incoming = doc.querySelector('[data-ddnn-grid]');
            var grid = root.querySelector('[data-ddnn-grid]');

            if (!incoming || !grid) throw new Error('grid');

            qsa('[data-ddnn-grid-item]', incoming).forEach(function (node) {
              grid.appendChild(document.importNode(node, true));
            });

            var next = doc.querySelector('[data-ddnn-loadmore]');
            var count = doc.querySelector('[data-ddnn-count]');
            var bar = doc.querySelector('[data-ddnn-progress]');

            if (count && root.querySelector('[data-ddnn-count]')) {
              root.querySelector('[data-ddnn-count]').textContent = count.textContent;
            }

            if (bar && root.querySelector('[data-ddnn-progress]')) {
              root.querySelector('[data-ddnn-progress]').style.width = bar.style.width;
            }

            bindCards(root);

            if (next) {
              load.dataset.url = next.dataset.url;
              load.disabled = false;
              load.textContent = old;
            } else {
              load.remove();
            }
          })
          .catch(function () {
            window.location.href = url;
          });
      });
    }

    bindCards(root);
  }

  function boot(scope) {
    qsa('[data-ddnn-collection]', scope || document).forEach(init);
  }
  if (!window.DDNNAdvancedHistoryBound) {
    window.DDNNAdvancedHistoryBound = true;
    window.addEventListener('popstate', function() {
      var root = document.querySelector('[data-ddnn-collection][data-ddnn-section-id]');
      if (root) renderFilteredUrl(window.location.href, false, root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot(document);
    });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });
})();
